const defaultState = () => ({
  stepsData: {},
  selectedStepsData: {},
  doctors: [],
  selectedDoctor: null,
});

export const bookingSteps = {
  state: defaultState(),
  mutations: {
    SET_STEPS_DATA(state, stepsData) {
      state.stepsData = stepsData;
      state.selectedStepsData = {};
      state.doctors = [];
      state.selectedDoctor = null;
    },
    SET_DOCTORS(state, doctors) {
      state.doctors = doctors || [];
    },
    SET_SELECTED_DOCTOR(state, doctor) {
      state.selectedDoctor = doctor || null;
    },
    RESET_BOOKING_STEPS(state) {
      Object.assign(state, defaultState());
    },
  },
  actions: {
    setStepsData({ commit }, stepsData) {
      commit("SET_STEPS_DATA", stepsData);
    },
    setDoctors({ commit }, doctors) {
      commit("SET_DOCTORS", doctors);
    },
    setSelectedDoctor({ commit }, doctor) {
      commit("SET_SELECTED_DOCTOR", doctor);
    },
    resetBookingSteps({ commit }) {
      commit("RESET_BOOKING_STEPS");
    },
  },
};
